import React from 'react'
import { connect } from "react-redux";
import ui from 'redux-ui'
import { Segment } from "semantic-ui-react";
import { Select } from "semantic-ui-react";
import { Button, Form, Header, Icon } from 'semantic-ui-react'
import { Modal } from 'semantic-ui-react-with-store'
import { mergeDossiers } from "../../actions/dossiers";
import { getDossiers } from "../../selectors/dossiers";
import PaginatedSelectorFieldControl from "../forms/fields/PaginatedSelectorFieldControl";

class MergeDossiersForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {mainDossierId: this.props.currentDossierId , otherDossierId: null}
  }

  render() {
    const showSubmit = this.state.mainDossierId && this.state.otherDossierId
    const translationScope='components.dossier.merge'

    return (
      <Modal size='tiny'
      trigger={this.props.trigger} closeIcon
      open={this.props.ui.open}
      onClose={() => this.props.updateUI('open', false)}
      onOpen={() => this.props.updateUI('open', true)}
      >
        <Header content={I18n.t(`${translationScope}.title`)} />
        <Modal.Content>
          <Segment basic loading={this.props.loading}>
            {I18n.t(`${translationScope}.explanation_p1`)}
            <br/><br/>
            {I18n.t(`${translationScope}.explanation_p2`)}
            <br/><br/>
            {I18n.t(`${translationScope}.explanation_p3`)}
            <br/><br/><br/>

            <Form>
              <Form.Field>
                <PaginatedSelectorFieldControl updateValue={this.handleMainSelect} translationScope={translationScope} name={'main_dossier'}
                                               options={{
                                                 keyWindowName: 'mergeDossiersForm',
                                                 entityName: 'dossier',
                                                 displayAttribute: this.getDisplayText,
                                               }} >
                </PaginatedSelectorFieldControl>
              </Form.Field>
              <Form.Field>
                <PaginatedSelectorFieldControl updateValue={this.handleOtherSelect} translationScope={translationScope} name={'other_dossier'}
                                               options={{
                                                 keyWindowName: 'mergeDossiersFormOther',
                                                 entityName: 'dossier',
                                                 displayAttribute: this.getDisplayText,
                                                 selector: (state)  => getDossiers('mergeDossiersFormOther')(state).filter(dossier => dossier.id !== this.state.mainDossierId)
                                               }} >
                </PaginatedSelectorFieldControl>
              </Form.Field>
            </Form>
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' disabled={!showSubmit} onClick={() => this.props.mergeDossiers(this.state.mainDossierId, this.state.otherDossierId, this.onMergeDone)}>
            <Icon name='fork' /> {I18n.t(`${translationScope}.merge`)}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  onMergeDone = () => {
    this.props.updateUI('open', false)
  }

  handleMainSelect  = (event, props) => {
    const selected = props.value
    if(selected === this.state.otherDossierId){
      this.setState({otherDossierId: null})
    }
      this.setState({mainDossierId: props.value})
  }

  handleOtherSelect = (event, props) => {
    this.setState({otherDossierId: props.value})
  }

  getDisplayText = (dossier) => {
    let displayText = `${dossier.patient?.firstName} ${dossier.patient?.lastName}`
    if(dossier.id === this.props.currentDossierId) {
      displayText += " (huidig dossier)"
    }
    return displayText
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.meta?.dossier?.loading,
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    mergeDossiers: (mainDossierId, otherId, onMergeDone) => {
        dispatch(mergeDossiers(mainDossierId, otherId)).then(onMergeDone)
    }
  }
}

export default ui({state: { open: false}})(connect(mapStateToProps, mapDispatchToProps)(MergeDossiersForm));
